export default function cmdClickNewTab(event, link) {
  if (event.ctrlKey || event.metaKey) {
    event.preventDefault();
    event.stopPropagation();
    window.open(link, '_blank');
  }
}
